import {AxiosResponse} from "axios";

import {axios} from "@/src/modules/core/lib";

import {BreakActionRequest, ExtendShiftRequest, ShiftEndRequest, ShiftStartRequest} from "../types";

const SHIFTS_META = {feature: "shifts"} as const;

class OfficerApi {
  shiftStart(data: ShiftStartRequest): Promise<AxiosResponse<unknown>> {
    return axios({
      url: "shift/start",
      method: "post",
      data,
      meta: {...SHIFTS_META, operation: "shift_start"},
    });
  }

  shiftEnd(data: ShiftEndRequest): Promise<AxiosResponse<unknown>> {
    return axios({
      url: "shift/end",
      method: "post",
      data,
      meta: {...SHIFTS_META, operation: "shift_end"},
    });
  }

  breakAction(data: BreakActionRequest): Promise<AxiosResponse<void>> {
    return axios({
      url: "break",
      method: "post",
      data,
      meta: {...SHIFTS_META, operation: "break_action"},
    });
  }

  extendShift(data: ExtendShiftRequest): Promise<AxiosResponse<void>> {
    return axios({
      url: "shift/extend",
      method: "post",
      data,
      meta: {...SHIFTS_META, operation: "shift_extend"},
    });
  }
}

export const officerApi = new OfficerApi();
